import {
  REQUEST_GET_LIST_RESTAURANT,
  REQUEST_GET_LIST_RESTAURANT_SUCCESS,
  REQUEST_GET_LIST_RESTAURANT_ERROR,
  REQUEST_GET_SEATS_AND_SLOTS,
  REQUEST_GET_SEATS_AND_SLOTS_SUCCESS,
  REQUEST_GET_SEATS_AND_SLOTS_ERROR,
  REQUEST_GET_RESERVATIONS,
  REQUEST_GET_RESERVATIONS_SUCCESS,
  REQUEST_GET_RESERVATIONS_ERROR,
  REQUEST_CREATE_RESTAURANT_CONFIG,
  REQUEST_CREATE_RESTAURANT_CONFIG_SUCCESS,
  REQUEST_CREATE_RESTAURANT_CONFIG_ERROR,
  REQUEST_UPDATE_RESTAURANT_CONFIG,
  REQUEST_UPDATE_RESTAURANT_CONFIG_SUCCESS,
  REQUEST_UPDATE_RESTAURANT_CONFIG_ERROR,
  REQUEST_CREATE_ALACARTE,
  REQUEST_CREATE_ALACARTE_SUCCESS,
  REQUEST_CREATE_ALACARTE_ERROR
} from "../actions";

export const getRequestRestaurant = items => ({
  type: REQUEST_GET_LIST_RESTAURANT,
  payload: items
});

export const getRequestRestaurantSuccess = items => ({
  type: REQUEST_GET_LIST_RESTAURANT_SUCCESS,
  payload: items
});

export const getRequestRestaurantError = error => ({
  type: REQUEST_GET_LIST_RESTAURANT_ERROR,
  payload: error
});

export const getSeatsAndSlotsRestaurant = items => ({
  type: REQUEST_GET_SEATS_AND_SLOTS,
  payload: items
});

export const getSeatsAndSlotsRestaurantSuccess = items => ({
  type: REQUEST_GET_SEATS_AND_SLOTS_SUCCESS,
  payload: items
});

export const getSeatsAndSlotsRestaurantError = error => ({
  type: REQUEST_GET_SEATS_AND_SLOTS_ERROR,
  payload: error
});

export const getReservations = items => ({
  type: REQUEST_GET_RESERVATIONS,
  payload: items
});

export const getReservationsSuccess = items => ({
  type: REQUEST_GET_RESERVATIONS_SUCCESS,
  payload: items
});

export const getReservationsError = error => ({
  type: REQUEST_GET_RESERVATIONS_ERROR,
  payload: error
});

export const createRestaurantConfig = items => ({
  type: REQUEST_CREATE_RESTAURANT_CONFIG,
  payload: items
});

export const createRestaurantConfigSuccess = items => ({
  type: REQUEST_CREATE_RESTAURANT_CONFIG_SUCCESS,
  payload: items
});

export const createRestaurantConfigError = error => ({
  type: REQUEST_CREATE_RESTAURANT_CONFIG_ERROR,
  payload: error
});

export const updateRestaurantConfig = items => ({
  type: REQUEST_UPDATE_RESTAURANT_CONFIG,
  payload: items
});

export const updateRestaurantConfigSuccess = items => ({
  type: REQUEST_UPDATE_RESTAURANT_CONFIG_SUCCESS,
  payload: items
});

export const updateRestaurantConfigError = error => ({
  type: REQUEST_UPDATE_RESTAURANT_CONFIG_ERROR,
  payload: error
});

export const createAlacarteRequest = items => ({
  type: REQUEST_CREATE_ALACARTE,
  payload: items
});

export const createAlacarteRequestSuccess = items => ({
  type: REQUEST_CREATE_ALACARTE_SUCCESS,
  payload: items
});

export const createAlacarteRequestError = error => ({
  type: REQUEST_CREATE_ALACARTE_ERROR,
  payload: error
});
